import { p as proxyCustomElement, H, h, a as Host } from './index.js';
import { d as defineCustomElement$8 } from './p-7jxIfyyn.js';
import { d as defineCustomElement$7 } from './p-Bgz_ZI5S.js';
import { d as defineCustomElement$6 } from './p-Da2lAZSv.js';
import { d as defineCustomElement$5 } from './p-PXnlnivq.js';
import { d as defineCustomElement$4 } from './p-CEvUoLql.js';
import { d as defineCustomElement$3 } from './p-B5UnDr4i.js';
import { d as defineCustomElement$2 } from './p-cR96ip-k.js';
import { d as defineCustomElement$1 } from './p-Bn01tsA6.js';

const emptyStateCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;align-items:center;background-color:var(--jw-theme-surface-tile-bg-color);box-sizing:border-box;display:flex;font-family:Open Sans;font-size:.875rem;font-weight:400;justify-content:center;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;padding:2rem 1rem}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host .content-wrapper{align-items:center;display:flex;flex:1;flex-direction:column;gap:1rem;justify-content:center;max-width:var(--jw-container-sm)}:host .inner-wrapper{align-items:center;display:flex;justify-content:center}:host h3{text-align:center}:host p{text-align:center}:host([type=error]) .content-wrapper{align-items:start;justify-content:start}:host([type=error]) h3{text-align:left}:host([type=error]) p{text-align:left;white-space:pre-wrap}:host([compact]){align-items:flex-start;background-color:var(--jw-theme-surface-level1-default-bg-color);border-radius:.25rem;display:flex;flex-direction:row;gap:.75rem;justify-content:flex-start;padding:.75rem 1rem 1rem}:host([compact]) .content-wrapper{align-items:flex-start;display:flex;gap:0;justify-content:flex-start;max-width:100%;padding:0}:host([compact]) .wui-icon-container{padding:.5rem 0}:host([compact]) .inner-wrapper{align-items:flex-start;display:flex;justify-content:flex-start}:host([compact]) p{text-align:left}";

const WuiEmptyState = /*@__PURE__*/ proxyCustomElement(class WuiEmptyState extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    renderGraphIcon(icon) {
        if (icon !== null) {
            return h("wui-graph-icon", { name: icon });
        }
        return h("wui-logo", { name: "mark-text", type: "color" });
    }
    renderWuiIcon(icon) {
        return (h("span", { class: "wui-icon-container" }, h("wui-icon", { name: icon })));
    }
    render() {
        if (typeof this.contents === 'undefined') {
            return null;
        }
        const { icon, heading, description, buttons, compact } = this.contents;
        return (h(Host, { compact: compact }, compact && this.renderWuiIcon(icon), h("div", { class: "content-wrapper" }, !compact && this.renderGraphIcon(icon), h("wui-layout", { type: "text-group", class: "inner-wrapper" }, compact ? h("h4", null, heading) : h("h3", null, heading), h("p", null, description)), buttons ? (h("wui-layout", { type: "button-group" }, buttons.map((b, k) => {
            return h("wui-button", { key: k, ...b });
        }))) : undefined)));
    }
    static get style() { return emptyStateCss; }
}, [257, "wui-empty-state", {
        "contents": [16]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-empty-state", "wui-button", "wui-graph-icon", "wui-icon", "wui-layout", "wui-loader", "wui-logo", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-empty-state":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiEmptyState);
            }
            break;
        case "wui-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "wui-graph-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-layout":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-logo":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { WuiEmptyState as W, defineCustomElement as d };
